export default "__VITE_ASSET__DCzwdmHW__"